module.exports = __webpack_public_path__ + "static/img/7.3c23f1b2.jpg";